<template lang="pug">
v-main
  v-container(fluid)
    v-flex
      v-card
        v-toolbar.elevation-0(color="white")
          v-toolbar-title(v-model="title") {{ title }}
          v-spacer
          v-btn(
            dark,
            v-if="$store.state.dataUsers.role == 'super_user'",
            color="blue-secondary",
            to="/data-master/create"
            class="elevation-0 custom__padding-btn"
          ) CREATE
        v-divider
        v-toolbar.elevation-0.mt-2.mb-4(color="white")
          v-text-field.hidden-sm-and-down.col-6(
            flat,
            append-icon="search",
            placeholder="Keyword (optional)",
            v-model="keyword",
            hide-details
          )
        v-divider
        v-card-text.pa-0
          v-data-table(
            :headers="dataHeaders",
            :items="dataItems",
            :search="keyword"
          )
            template(v-slot:item.logo="{ item }")
              img.pt-3.pb-3(:src="item.logo", height="120px", width="auto")

            template(v-slot:item.data-table-expand="{ headers, item }")
              v-icon.mr-2(
                title="edit",
                color="green",
                @click="onEdit(item.id)"
              )
                | edit

            template(v-slot:no-data)
              div.pa-15 
                img(src="../assets/icon/empty-bu.png")
                div(class="empty__title mt-1") No data available
                div(class="empty__subtitle") Please contact support i-Memo.

            template(v-slot:no-results)
              div.pa-15 
                img(src="../assets/icon/empty-bu.png")
                div(class="empty__title mt-1") Data not found
                div(class="empty__subtitle") Data is empty or Try adjusting your filters.
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "DataMasterList",
  props: {
    title: String,
  },
  mounted() {
    this.getDataBu();
  },
  computed: {
    ...mapState(["loadingData", "showDrawer"]),
  },
  data() {
    return {
      keyword: "",
      bisnis_unit: [],
      dataHeaders: [
        { text: "Business Unit Name ", value: "bu_name" },
        { text: "Business Unit Logo", value: "logo", filterable: false },
        { text: "Status", value: "is_active" },
        { text: "Actions", value: "data-table-expand" },
      ],
      dataItems: [],
    };
  },
  methods: {
    onEdit(item) {
      this.$router.push({
        name: "Data Master Edit",
        params: { id: item },
      });
    },
    getDataBu: function () {
      let token = localStorage.getItem("token");
      axios
        .get(process.env.VUE_APP_API + `/business-unit/list`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          let resArr = [];
          res.data.data.filter(function (item) {
            
            var i = resArr.findIndex((x) => x.id == item.id);
            if (i <= -1) {
              item.is_active == true
                ? (item.is_active = "Active")
                : (item.is_active = "Non Active");
              if (!item.logo) {
                item.logo = require('../assets/no-image.jpeg')
              }
              resArr.push(item);
            }
            return null;
          });
          this.dataItems = resArr;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}

button.custom__padding-btn {
  padding: 1.4rem 2rem !important;
}
</style>

